(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["email-capture-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    // Find all email capture forms on the page
    const emailCaptureForms = document.querySelectorAll('.input-wrapper[data-block-id]');

    emailCaptureForms.forEach((buttonContainer) => handleEmailCaptureFormsfunction(buttonContainer));

    function handleEmailCaptureFormsfunction(buttonContainer) {
      // Get settings from data attributes
      const blockId = buttonContainer.dataset.blockId;
      const successMessage = buttonContainer.dataset.successMessage;
      const buttonText = buttonContainer.dataset.buttonText;

      // Get form elements
      const signupButton = document.getElementById('signupButton-' + blockId);
      const emailInput = document.getElementById('emailInput-' + blockId);

      if (!signupButton || !emailInput) return;

      let currentPhase = 'initial'; // Can be 'initial' or 'email'

      signupButton.addEventListener('click', () => {
        if (currentPhase === 'initial') {
          buttonContainer.classList.add('email-phase');
          signupButton.textContent = '\u2192';
          emailInput.focus();
          currentPhase = 'email';
          return;
        }

        if (currentPhase === 'email') {
          if (emailInput.checkValidity()) {
            // Push to dataLayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'form-submitted',
              data: {
                form_id: 'central-hvac-pre-order',
                email: emailInput.value,
              },
            });

            // Transition to the final "Registered" state
            buttonContainer.classList.remove('email-phase');
            buttonContainer.classList.add('registered-phase');
            signupButton.textContent = successMessage;
          } else {
            // Use HTML5 validation to show error
            emailInput.reportValidity();
          }
        }
      });

      emailInput.addEventListener('blur', () => {
        // Reset to initial state if user clicks away without entering anything
        if (currentPhase === 'email' && emailInput.value.trim() === '') {
          buttonContainer.classList.remove('email-phase');
          signupButton.textContent = buttonText;
          currentPhase = 'initial';
        }
        // If they have started typing, keep the expanded view (do nothing)
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["popover-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('popover-menu-component')) {
    const supportsAnchorPositioning = CSS.supports('anchor-name', '--test');

    class PopoverMenuComponent extends HTMLElement {
      connectedCallback() {
        // Find elements - use El suffix to avoid HTML attribute conflicts
        this.triggerEl = this.querySelector('button[ref="trigger"]');
        this.panelEl = this.querySelector('div[ref="popover"]');
        this.labelEl = this.querySelector('[ref="label"]');

        if (!this.triggerEl || !this.panelEl) return;

        // Get original position class
        const classes = this.panelEl.getAttribute('class') || '';
        const positionMatch = classes.match(/position-\S+/);
        this.originalPositionClass = positionMatch ? positionMatch[0] : 'position-bottom-end';

        this.bindEvents();
      }

      disconnectedCallback() {
        // Clean up window resize listener to prevent memory leaks
        if (this.boundResizeHandler) {
          window.removeEventListener('resize', this.boundResizeHandler);
        }
      }

      bindEvents() {
        // Handle popover toggle
        this.panelEl.addEventListener('toggle', this.handleToggle.bind(this));

        // Handle menu item clicks
        this.panelEl.addEventListener('click', this.handleClick.bind(this));

        // Keyboard navigation
        this.panelEl.addEventListener('keydown', this.handleKeydown.bind(this));

        // Close on resize (JS positioning only)
        if (!supportsAnchorPositioning) {
          this.boundResizeHandler = () => {
            if (this.panelEl?.matches(':popover-open')) this.panelEl.hidePopover();
          };
          window.addEventListener('resize', this.boundResizeHandler);
        }
      }

      handleToggle(e) {
        const isOpen = e.newState === 'open';
        this.triggerEl.setAttribute('aria-expanded', isOpen);

        if (isOpen && !supportsAnchorPositioning) {
          this.resetPosition();
          this.updatePosition();
          requestAnimationFrame(() => {
            requestAnimationFrame(() => this.adjustPosition());
          });
        }
      }

      handleClick(e) {
        const item = e.target.closest('.popover-menu__item');
        if (!item) return;

        e.preventDefault();

        // Update all items - remove selection
        const allItems = this.panelEl.querySelectorAll('.popover-menu__item');
        for (const i of allItems) {
          i.classList.remove('is-selected');
          i.removeAttribute('aria-current');
        }

        // Mark clicked item as selected
        item.classList.add('is-selected');
        item.setAttribute('aria-current', 'true');

        // Get the selected label
        const selectedLabel = item.querySelector('.popover-menu__item-label')?.textContent?.trim();

        // Update the trigger button label
        if (this.labelEl && selectedLabel) {
          this.labelEl.textContent = selectedLabel;
        }

        // Dispatch custom event
        this.dispatchEvent(
          new CustomEvent('popover-menu:select', {
            bubbles: true,
            detail: {
              value: item.dataset.value,
              label: selectedLabel,
            },
          }),
        );

        // Close popover after brief delay to show selection
        setTimeout(() => this.panelEl.hidePopover(), 150);
      }

      handleKeydown(e) {
        const items = [...this.panelEl.querySelectorAll('.popover-menu__item')];
        const idx = items.indexOf(document.activeElement);

        switch (e.key) {
          case 'ArrowDown':
            e.preventDefault();
            items[(idx + 1) % items.length]?.focus();
            break;
          case 'ArrowUp':
            e.preventDefault();
            items[(idx - 1 + items.length) % items.length]?.focus();
            break;
          case 'Home':
            e.preventDefault();
            items[0]?.focus();
            break;
          case 'End':
            e.preventDefault();
            items[items.length - 1]?.focus();
            break;
          case 'Escape':
            this.panelEl.hidePopover();
            this.triggerEl.focus();
            break;
        }
      }

      resetPosition() {
        this.panelEl.classList.remove(
          'position-bottom-end',
          'position-bottom-start',
          'position-top-end',
          'position-top-start',
        );
        this.panelEl.classList.add(this.originalPositionClass);
      }

      updatePosition() {
        const rect = this.triggerEl.getBoundingClientRect();
        this.panelEl.style.setProperty('--anchor-top', rect.top);
        this.panelEl.style.setProperty('--anchor-right', window.innerWidth - rect.right);
        this.panelEl.style.setProperty('--anchor-bottom', window.innerHeight - rect.bottom);
        this.panelEl.style.setProperty('--anchor-left', rect.left);
        this.panelEl.style.setProperty('--anchor-height', rect.height);
        this.panelEl.style.setProperty('--anchor-width', rect.width);
      }

      adjustPosition() {
        const triggerRect = this.triggerEl.getBoundingClientRect();
        const popoverRect = this.panelEl.getBoundingClientRect();
        const vh = window.innerHeight;
        const vw = window.innerWidth;
        const pad = 8;

        const spaceBelow = vh - triggerRect.bottom - pad;
        const spaceAbove = triggerRect.top - pad;
        const spaceRight = vw - triggerRect.left - pad;
        const spaceLeft = triggerRect.right - pad;

        const vertical = popoverRect.height > spaceBelow && spaceAbove > spaceBelow ? 'top' : 'bottom';
        const horizontal = popoverRect.width > spaceRight && spaceLeft > spaceRight ? 'start' : 'end';
        const newClass = `position-${vertical}-${horizontal}`;

        if (!this.panelEl.classList.contains(newClass)) {
          this.panelEl.classList.remove(
            'position-bottom-end',
            'position-bottom-start',
            'position-top-end',
            'position-top-start',
          );
          this.panelEl.classList.add(newClass);
          this.updatePosition();
        }
      }
    }

    customElements.define('popover-menu-component', PopoverMenuComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tooltip"] && !Shopify.designMode) return;
  try {
    class TooltipManager {
    constructor() {
      this.isTouch = 'ontouchstart' in window;
      this.activeTooltips = new Map();
      this.init();
    }

    init() {
      // Event delegation handles all tooltips, including dynamically added ones
      document.addEventListener('mouseenter', (e) => this.withTrigger(e, this.showTooltip), true);
      document.addEventListener('mouseleave', (e) => this.withTrigger(e, this.hideTooltip), true);
      document.addEventListener('focusin', (e) => this.withTrigger(e, this.showTooltip));
      document.addEventListener('focusout', (e) => this.withTrigger(e, this.hideTooltip));

      if (this.isTouch) {
        document.addEventListener('click', (e) => this.withTrigger(e, this.toggleTooltip, true));
      }

      document.addEventListener('click', this.handleOutsideClick.bind(this));
      document.addEventListener('keydown', this.handleKeydown.bind(this));
    }

    // Helper method to reduce repetitive trigger finding
    withTrigger(event, action, preventDefault = false) {
      // Guard against non-element targets (text nodes, comments, etc.)
      if (!event.target || typeof event.target.closest !== 'function') return;

      const trigger = event.target.closest('[data-tooltip-trigger]');
      if (trigger) {
        if (preventDefault) event.preventDefault();
        action.call(this, trigger);
      }
    }

    handleOutsideClick(e) {
      // Guard against non-element targets and hide tooltips if click is outside
      if (!e.target || typeof e.target.closest !== 'function' || !e.target.closest('[data-tooltip-trigger]')) {
        this.hideAllTooltips();
      }
    }

    handleKeydown(e) {
      if (e.key === 'Escape') {
        this.hideAllTooltips();
      }
    }

    showTooltip(trigger) {
      const content = trigger.querySelector('[data-tooltip-content]');
      if (!content) return;

      this.clearTooltipTimeout(trigger);
      content.classList.add('show');
      content.setAttribute('aria-hidden', 'false');

      // Adjust position to prevent viewport overflow
      this.adjustPosition(trigger, content);
    }

    adjustPosition(trigger, content) {
      // Reset to default centered position
      content.style.left = '';
      content.style.transform = '';
      content.style.removeProperty('--arrow-left');

      requestAnimationFrame(() => {
        const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
        const padding = rem;
        const viewportWidth = window.innerWidth;
        const rect = content.getBoundingClientRect();
        const triggerRect = trigger.getBoundingClientRect();
        const triggerCenter = triggerRect.left + triggerRect.width / 2;

        // Check if tooltip overflows viewport
        const overflowRight = rect.right - (viewportWidth - padding);
        const overflowLeft = padding - rect.left;

        if (overflowRight > 0 || overflowLeft > 0) {
          // Calculate where tooltip left edge should be (in viewport coords) to fit
          let desiredLeft = rect.left;

          if (overflowRight > 0) {
            desiredLeft = rect.left - overflowRight;
          } else if (overflowLeft > 0) {
            desiredLeft = padding;
          }

          // Convert to offset from trigger center (since CSS uses left: 50%)
          const offsetFromCenter = desiredLeft - triggerCenter + rect.width / 2;

          // Apply position
          content.style.left = `calc(50% + ${offsetFromCenter}px)`;
          content.style.transform = 'translateX(-50%)';

          // Calculate arrow position - trigger center relative to new tooltip position
          const arrowLeft = triggerCenter - desiredLeft;
          content.style.setProperty('--arrow-left', `${arrowLeft}px`);
        }
      });
    }

    hideTooltip(trigger) {
      const content = trigger.querySelector('[data-tooltip-content]');
      if (!content) return;

      const timeoutId = setTimeout(() => {
        content.classList.remove('show');
        content.setAttribute('aria-hidden', 'true');
        this.activeTooltips.delete(trigger);
      }, 100);

      this.activeTooltips.set(trigger, timeoutId);
    }

    toggleTooltip(trigger) {
      const content = trigger.querySelector('[data-tooltip-content]');
      if (!content) return;

      if (content.classList.contains('show')) {
        this.hideTooltip(trigger);
      } else {
        this.showTooltip(trigger);
      }
    }

    hideAllTooltips() {
      document.querySelectorAll('.tooltip-content.show').forEach((content) => {
        content.classList.remove('show');
        content.setAttribute('aria-hidden', 'true');
      });
      this.activeTooltips.clear();
    }

    clearTooltipTimeout(trigger) {
      const timeoutId = this.activeTooltips.get(trigger);
      if (timeoutId) {
        clearTimeout(timeoutId);
        this.activeTooltips.delete(trigger);
      }
    }
  }

  // Initialize tooltip system
  new TooltipManager();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["utility-email-signup-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('utility-email-signup')) {
    class UtilityEmailSignup extends HTMLElement {
      connectedCallback() {
        const form = this.querySelector('form');
        if (!form) return;
        if (form.dataset.signupInitialized === 'true') return;

        form.dataset.signupInitialized = 'true';

        form.addEventListener('submit', (event) => {
          event.preventDefault();
          form.classList.add('is-submitted');
        });
      }
    }

    customElements.define('utility-email-signup', UtilityEmailSignup);
  }
  } catch(e) { console.error(e); }
})();

})();
